import { Component } from "@builder.io/sdk";

export const heroCiAppConfig: Component = {
  name: "Hero CI App",
  inputs: [
    {
      name: "id",
      type: "string",
      defaultValue: "hero",
      advanced: true,
    },
    {
      name: "className",
      type: "string",
      advanced: true,
    },
    {
      name: "heading",
      type: "string",
      defaultValue: "Smart Staffing for Smarter Care",
    },
    {
      name: "subheading",
      type: "longText",
      defaultValue:
        "Care Indeed introduces the all-new Care Indeed App – your ultimate staffing solution. Built for care facilities, our platform simplifies scheduling, tracking, and communication so your team delivers better care with less hassle.",
    },
    {
      name: "primaryCta",
      friendlyName: "Primary Button",
      type: "object",
      defaultValue: {
        text: "Request a Demo",
        href: "/care-assessment",
        ariaLabel: "Request a Demo",
      },
      subFields: [
        {
          name: "text",
          friendlyName: "Button Text",
          type: "string",
        },
        {
          name: "href",
          friendlyName: "Button Link",
          type: "string",
        },
        {
          name: "ariaLabel",
          friendlyName: "Button Aria Label",
          type: "string",
        },
      ],
    },
    {
      name: "cards",
      type: "list",
      defaultValue: [
        {
          title: "Shift Management",
          subtitle: "Scheduling",
          body: "Fill positions faster with smart scheduling that matches the right staff to each shift. No more overtime headaches or coverage gaps.",
        },
        {
          title: "Unified Credentialing",
          subtitle: "Compliance",
          body: "One secure hub for all staff licenses and certifications. Automated tracking ensures you're always compliant.",
        },
        {
          title: "24/7 Care Team Chat",
          subtitle: "Support",
          body: "Never face a staffing crisis alone. Human support is ready whenever you call.",
        },
        {
          title: "Streamlined Billing",
          subtitle: "Invoicing",
          body: "Simplify your process with automated invoicing that integrates with scheduling data. Get paid faster, with less effort.",
        },
      ],
      subFields: [
        {
          name: "title",
          friendlyName: "Card Title",
          type: "string",
        },
        {
          name: "subtitle",
          friendlyName: "Card Subtitle",
          type: "string",
          enum: ["Scheduling", "Compliance", "Support", "Invoicing"],
        },
        {
          name: "body",
          friendlyName: "Card Body",
          type: "longText",
        },
      ],
    },
  ],
};
